import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './filter-inbox.actions';

export interface InboxFilterState {
  loadFavorite: boolean;
  status: 'active' | 'expired';
}

export const initialState: InboxFilterState = {
  loadFavorite: false,
  status: 'active',
};

const createFilterInboxReducer = createReducer(
  initialState,
  on(
    fromActions.setStatus,
    (state: InboxFilterState, deliveryStatus: { status: 'active' | 'expired' }) => ({ ...state, status: deliveryStatus.status }),
  ),
  on(fromActions.loadFavorite, (state: InboxFilterState, data) => {
    const { loadFavorite } = data;
    return { ...state, loadFavorite };
  }),
);

export function filterInboxReducer(state: InboxFilterState, action: Action) {
  return createFilterInboxReducer(state, action);
}

export const filterReducerKey = 'filterInbox';
